import React, { FunctionComponent, useContext } from 'react'
import { Collection } from 'server'
import { Button, List, Skeleton, Space, Switch } from 'antd'
import { MapSettingsContext } from '../../../../contexts/MapSettingsContext'
import MapSettingsContextInterface from '../../../../contexts/MapSettingsContext/MapSettingsContextInterface'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'
import { getAllData } from '../../../../utils/data'
import useQueryListener from '../../../../hooks/data/useQueryListener'
import { EditOutlined } from '@ant-design/icons'
import { formatTimestamp } from '../../../../utils/time'

interface IProps {
  collection: Collection
  setSelectedCollection: (value: Collection | undefined) => void
}

const CollectionsListItem: FunctionComponent<any> = (props: IProps) => {
  const { collection, setSelectedCollection } = props

  const { selectedCollections, setSelectedCollections } = useContext(
    MapSettingsContext
  ) as MapSettingsContextInterface

  const client = useFeathersClient()

  const collectionDevicesQuery = {
    collection_id: collection.id,
    active: true
  }

  const {
    data: collectionDevices,
    isLoading: collectionDevicesLoading,
    refetch
  } = useQuery({
    queryKey: ['collection-device', 'find', collectionDevicesQuery],
    queryFn: () => getAllData(client, 'collection-device', collectionDevicesQuery),
    gcTime: 0
  })

  useQueryListener('collection-device', refetch)

  const handleChange = (value: boolean) => {
    setSelectedCollections((prev: number[]) => {
      if (value) {
        return [...prev, collection.id]
      }
      return prev.filter((id: number) => id !== collection.id)
    })
  }

  return (
    <List.Item
      extra={
        <Space>
          <Button type={'dashed'} icon={<EditOutlined />} onClick={() => setSelectedCollection(collection)} />
          <Switch checked={selectedCollections.includes(collection.id)} onChange={handleChange} />
        </Space>
      }
    >
      <List.Item.Meta
        title={collection.name}
        description={
          <>
            <Skeleton loading={collectionDevicesLoading} active={true} paragraph={false}>
              <span>Units: {collectionDevices?.length}</span>
            </Skeleton>
            <br />
            <span>{formatTimestamp(collection.created_at)}</span>
          </>
        }
      />
    </List.Item>
  )
}

export default CollectionsListItem
